import React from 'react';
import { capitalizeFirstLetter } from "../../../../../utils/string/string";
import { getTranslation } from '../../../../../assets/creator/translations';
import ColorPicker from '../../../../../components/ColorPicker/ColorPicker';


const getColorChangeHandler = (colorChangeHandler, variable) => {
    if (typeof colorChangeHandler === 'function') {
        return (newColor) => { colorChangeHandler(variable, newColor) };
    } else {
        return () => { };
    }
}


const getVariableTranslation = (variable) => getTranslation("Clv_" + capitalizeFirstLetter(variable));

const VariableSet = ({ className, variables, onColorSelect, colorSource, containerRef }) => {
    if (!Array.isArray(variables)) {
        return null;
    }
    
    return (
        <ul className={className}>
          
            {variables.map(variable => (
                <VariableControl
                    key={variable}
                    variable={variable}
                    variables={variables}
                    onColorSelect={onColorSelect}
                    colorSource={colorSource}
                    containerRef={containerRef}
                >
                </VariableControl>
              
            ))}
        </ul>
    );
}

const VariableControl = ({ variable, onColorSelect, colorSource, containerRef, variables }) => (

    <li className="color-variable" >
        <div className="color-variable__name">{getVariableTranslation(variable)}</div>
        <ColorPicker
            color={colorSource(variable)}
            variables={variables}
            colorSource={colorSource}
            onChange={getColorChangeHandler(onColorSelect, variable)}
            containerRef={containerRef}
        />
    </li>
)

export default VariableSet;